import { KhandaIcon } from './KhandaIcon';

/**
 * author: Michael Irigoyen
 * id 8F5B2685-A656-45ED-89C2-032E76322358
 * name khanda
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/khanda.svg
 * tags
 * - Religion 
 */
export const SikhIcon = KhandaIcon;
export default SikhIcon